import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Divider } from '@dealstack/frontend/shared/components/fundament/Divider/Divider';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import React, { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	bodyText: string;
	title: string;
	child?: React.ReactNode;
}

const EmailPreview = ({ className, bodyText, title, child }: Props) => {
	const bodyTextParagraphs = bodyText.split('\n');

	return (
		<div className={className}>
			<Title variant="h5" center>
				{title}
			</Title>
			<BodyText variant="caption" colorFaded>
				{bodyTextParagraphs.map((paragraph: string, index) => (
					<p key={`${paragraph}${index}`}>{paragraph}</p>
				))}
			</BodyText>
			{child}
			<Divider />
			<BrandLogoColored variant="dealstack-logo-black" />
			{/*hided by Joel's request, unlock it when times come - 25.08.2022 D.Zghinnik*/}
			{/*<FooterItemsWrapper>*/}
			{/*    {BOTTOM_BUTTONS.map(title => (*/}
			{/*        <Button size="small" variant="text" key={title}>*/}
			{/*            {t(title)}*/}
			{/*        </Button>*/}
			{/*    ))}*/}
			{/*</FooterItemsWrapper>*/}
		</div>
	);
};

const Title = styled(Text)`
	margin-top: 3em;
	font-weight: 800;
	white-space: pre-line;
`;

const BodyText = styled(Text)`
	margin: 2em 0;
	align-self: flex-start;

	p {
		margin-bottom: 1em;
	}
`;

const BrandLogoColored = styled(Icon)``;

const Memoized = memo(EmailPreview);
const Styled = styled(Memoized)`
	display: flex;
	align-items: center;
	flex-direction: column;
	max-width: 28rem;
	padding: 1.4em 0.8em;
	overflow: hidden;
	border-radius: 0.5rem;
	background-color: ${({ theme }) => theme.v2.color.neutral[200]};

	${BrandLogoColored} {
		--size: 6em;
		margin: -2em 0;
		padding-top: 1em;
	}

	${Divider} {
		width: 100%;
		margin-top: 2em;
		background-color: ${({ theme }) => theme.v2.color.neutral[300]};
	}

	button {
		pointer-events: none;
	}
`;

export { Styled as EmailPreview };
